<template>
  <div class="notice-components">
    <div class="notice-body" v-if="messgeCount > 0">
      <!-- <Poptip placement="left-start" width="400"> -->
      <!-- <img src="../../static/images/notice-img.png" @click="getNoReadList()" /> -->
      <!-- <div class="notice-content" slot="content">
          <Table :columns="columns1" :data="data1">
            <template slot-scope="{ row, index }" slot="action">
              <a @click="viewInfo(row)">查看</a>
            </template>
          </Table>
        </div>
      </Poptip> -->
    </div>
    <messageNoticeAdmin
      @tableReload="getNoReadList"
      ref="messageNoticeAdmin"
    ></messageNoticeAdmin>
  </div>
</template>

<script>
import { _baseUrl } from "~/plugins/request.js";
import Cookie from "js-cookie";
import messageNoticeAdmin from "../../pages/index/stationNotification/myRelease/components/edit";
export default {
  components: {
    messageNoticeAdmin
  },
  data() {
    return {
      url: "",
      columns1: [
        {
          title: "通知标题",
          key: "noticeTitle",
          ellipsis: true,
          align: "center"
        },
        {
          title: "操作",
          slot: "action",
          align: "center"
        }
      ],
      data1: [],
      count: 0
    };
  },
  computed: {
    messgeCount() {
      return this.$store.state.stationNotification.messageCount;
    }
  },
  mounted() {
    let url = _baseUrl;
    this.url = url.replace("http://", "").replace("https://", "");
    console.log('socket-url:', this.url);
    this.initSocket();
  },
  methods: {
    initSocket() {
      let userInfo = this.userInfo || Cookie.get("userInfo");
      userInfo = JSON.parse(userInfo);
      var ws = new WebSocket(
        `ws://${this.url}socketServer/notice/${userInfo.userId}`
      );
      let that = this;
      ws.onopen = function() {
        // Web Socket 已连接上，使用 send() 方法发送数据
        // console.log("长连接已连接");
      };
      ws.onmessage = function(evt) {
        // console.log("evt-------" + evt);
        var received_msg = evt.data;
        received_msg = JSON.parse(received_msg);
        let count = received_msg.count;
        that.$store.commit("stationNotification/SET_MESSAGE_COUNT", count);
        // console.log("received_msg-------" + received_msg);
        // console.log("数据已接收");
        if (count > 0 && count > this.count) {
          // that.$notify({
          //   title: "通知",
          //   message: "收到一条通知消息请查看",
          //   position: "bottom-right",
          //   duration: 0
          // });
        }
        this.count = count;
      };

      ws.onclose = function() {
        // 关闭 websocket
        // console.log("连接已关闭");
      };
    },
    getNoReadList() {
      // this.$store
      //   .dispatch("stationNotification/getNoReadList")
      //   .then(res => {
      //     this.data1 = res;
      //   })
      //   .catch(error => {});
      this.$router.push({ path: "/notice" });
    },
    viewInfo(row) {
      this.$refs.messageNoticeAdmin.viewInfo(row.id, 0);
    }
  }
};
</script>

<style scope lang="less">
.notice-components {
  position: absolute;
  bottom: 10px;
  right: 10px;
  .notice-body {
    .notice-content {
    }
  }
}
</style>
